module.exports = __webpack_public_path__ + "static/media/pipe_down.a71b7837.png";


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/pipe_down.png
// module id = 245
// module chunks = 0